export default __webpack_public_path__ + "static/media/dim_logo_color.536892e3.svg";